
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import rootConfig from '@root/config/root.config';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';

interface Props {
  article: ArticleData;
  size: string;
}

interface Computed {
  disableLogin: boolean;
  isPressPelease: boolean;
  isPtContent: boolean;
}

interface Methods {
  scrollToPaywall: () => void;
}

export default Vue.extend<unknown, unknown, Computed, Props, Methods>({
  components: {
    PianoCustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
  },
  computed: {
    disableLogin() {
      const { specialFeatures } = this.$channelConfig('settings').application || {};
      return rootConfig.disableLogin || !!this.$channelConfig('settings').disableLogin || specialFeatures?.hideSignupAndOrders?.enabled;
    },
    isPressPelease() {
      const settings: any = this.article.settings;
      return !!settings['icon.press_release'] || !!settings['frontPagePressRelease'];
    },
    isPtContent() {
      const settings: any = this.article.settings;
      return (
        (!!settings['icon.reklama'] ||
          !!settings['frontPageSponsoredContent'] ||
          this.article.primaryCategory.channel.url === 'www.delfi.lt/uzsakomasis-turinys') &&
        !settings['frontPageSupportedContent']
      );
    },
  },
  methods: {
    scrollToPaywall() {
      const paywall = document.querySelector(`#article-${this.article.id} .article-paywall`) as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
  },
});
